import { ChoiceNode } from "./ChoiceNode";

export class ExclusiveChoiceNode<T, C> extends ChoiceNode<T, C> {
    constructor(identifier: string, data: T) {
        super(identifier, data);
    }
}
